import React, { useState, useContext, useEffect } from 'react'
import {
  Checkbox,
  FormControlLabel,
  LineChartIcon,
} from '../../../../../Components/LazyComponents'
import { Head3 } from '../../../../../Components/Typography/Text.styles'
import { PlayerProfileContext } from '../../../../../Context'
import {
  POSITION_STATS_TOGGLE,
  AVAILABLE_STATS_TOGGLE,
} from '../../../../../Constant/statsProcess'
import { StatDefinition } from './careerProgressionChart.types'
import {
  StyledCard,
  HeaderContainer,
  TitleContainer,
  ContentContainer,
  StatSelectionPanel,
  StatCheckboxLabel,
  ColorIndicator,
  StatCheckboxCon,
} from './styles'
import { logEvent } from '../../../../../Utils'
import { ANALYTICS_TAGS } from '../../../../../Constant'
import { CareerProgressionChart } from './careerChart/CareerProgressionChart'

export const CareerProgression: React.FC = () => {
  const { player } = useContext(PlayerProfileContext)!
  const [statsForToggle, setStatsForToggle] = useState<StatDefinition[]>([])
  const [selectedStats, setSelectedStats] = useState<string[]>([])

  useEffect(() => {
    getToggleStats()
  }, [player])

  const toggleStat = (statId: string) => {
    setSelectedStats([statId])

    logEvent(ANALYTICS_TAGS.player_stats_chart_toggle_stat, {
      statId,
      selected: true,
    })
  }

  const getToggleStats = () => {
    let positionList = []
    if (!player?.position) {
      positionList = POSITION_STATS_TOGGLE.A
    } else {
      positionList = POSITION_STATS_TOGGLE[player?.position]
    }
    const availableStats = AVAILABLE_STATS_TOGGLE.filter((stat) =>
      positionList.includes(stat.id)
    )
    const sortedAvailableStats = availableStats.sort(
      (a, b) => positionList.indexOf(a.id) - positionList.indexOf(b.id)
    )

    setSelectedStats([sortedAvailableStats[0].id])
    setStatsForToggle(sortedAvailableStats)
  }

  if (!player?.allSeasonStats || player.allSeasonStats.length < 1) return null

  return (
    <StyledCard>
      <HeaderContainer>
        <LineChartIcon sx={{ fontSize: 20, marginTop: 1 }} />
        <TitleContainer>
          <Head3>Career Progression</Head3>
        </TitleContainer>
      </HeaderContainer>
      <ContentContainer>
        <StatSelectionPanel>
          <StatCheckboxCon>
            {statsForToggle.map((stat) => (
              <FormControlLabel
                key={stat.id}
                control={
                  <Checkbox
                    id={`stat-${stat.id}`}
                    checked={selectedStats.includes(stat.id)}
                    onChange={() => toggleStat(stat.id)}
                    sx={{ padding: '4px' }}
                  />
                }
                label={
                  <StatCheckboxLabel htmlFor={`stat-${stat.id}`}>
                    <ColorIndicator style={{ backgroundColor: stat.color }} />
                    {stat.name}
                  </StatCheckboxLabel>
                }
                sx={{ marginBottom: '4px' }}
              />
            ))}
          </StatCheckboxCon>
        </StatSelectionPanel>
        <CareerProgressionChart
          statsForToggle={statsForToggle}
          selectedStats={selectedStats}
        />
      </ContentContainer>
    </StyledCard>
  )
}
